import React, { useRef } from 'react';

import css from './floating-blob.module.scss';

interface Props {
  ref: React.Ref<HTMLDivElement>;
  variant?: 'cyan' | 'pink';
}

export const FloatingBlob: React.FC<Props> = ({ ref, variant = 'cyan' }) => {
  return <div ref={ref} className={`${css.blob} ${css[variant]}`} />;
};
